export default __webpack_public_path__ + "static/media/qa-reply-icon.27a7b253.svg";